import { ACTION } from './constants';
import request from '../../../../../utils/request';
import { requestConfig } from '../../../../../config/apiResource';
import {showMainLoader, hideMainLoader} from '../../../../actions';

const decryptAES = (encryptedData) => {
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PRIV_KEY);
    let header = encryptedData.substring(0, encryptedData.lastIndexOf("|"));
    let data = CryptoJS.enc.Base64.parse(encryptedData.substring(encryptedData.lastIndexOf("|")+1, encryptedData.length));
    let responseData = readAesResponsePayload(crypt.decrypt(header), data);
    return responseData;
    // response.data = angular.fromJson(responseData);
}

const readAesResponsePayload = (header, data) => {
    let iv = CryptoJS.enc.Base64.parse(header.substring(0, header.lastIndexOf("|")));
    let key = CryptoJS.enc.Base64.parse(header.substring(header.lastIndexOf("|")+1, header.length));
    let decryptJson = CryptoJS.AES.decrypt({
      ciphertext: data
    }, key, {iv: iv});
    return decryptJson.toString(CryptoJS.enc.Utf8);
  }


export function verifyECartKYC(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyECartKYC(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.VERIFY_ECART_KYC, data: JSON.parse(decryptAES(response)) });
                console.log(decryptAES(response))
                return JSON.parse(decryptAES(response));

            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Verify KYC data: " + error)
            });
    }
}

export function forceLogout(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.forceLogout(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.FORCE_LOGOUT, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Verify KYC data: " + error)
            });
    }
}

const encryptRSA = (data) => {
    /*Encrypt*/
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PASS_PUB_KEY);
    // Encrypt the data with the public key.
    return crypt.encrypt(data);
}

function encryptAES(data) {
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PASS_PUB_KEY);
    let key =  CryptoJS.lib.WordArray.random(128/8); //16bit
    let IV =  CryptoJS.lib.WordArray.random(128/8); //8bit
    let aesEncrypted = CryptoJS.AES.encrypt(data, key, { iv: IV });
    let ivAndKey = CryptoJS.enc.Base64.stringify(IV) + "|" + CryptoJS.enc.Base64.stringify(key);
    return (crypt.encrypt(ivAndKey) + "|" + CryptoJS.enc.Base64.stringify(aesEncrypted.ciphertext));
}

function encryptAESforKYC(data) {
    let cypherText = CryptoJS.AES.encrypt(JSON.stringify(data), 'tgkpdi45sd');
    return (cypherText.toString());
}

const decrypttRSA = (data) => {
    /*Encrypt*/
    let crypt = new JSEncrypt();
    crypt.setKey(ACTION.PRIV_KEY);
    // Encrypt the data with the public key.
    return crypt.decrypt(data);
}

export function verifyECartOTP(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.verifyOTPJava(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.VERIFY_ECART_OTP, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Verify OTP data: " + error)
            });
    }
}

export function resendOTP(params) {
    return dispatch => {
        dispatch(showMainLoader());
        return request(requestConfig.resendOTPJava(params))
            .then((response) => {
                dispatch(hideMainLoader());
                response && dispatch({ type: ACTION.RESEND_OTP, data: JSON.parse(decryptAES(response)) });
                return JSON.parse(decryptAES(response));
            }).catch((error) => {
                dispatch(hideMainLoader());
                console.log("Got Error with Resend OTP data: " + error)
            });
    }
}

export function cleanAuthContent() {
    return {type: ACTION.CLEAN_AUTH_CONTENT}
}

export {encryptRSA, decryptAES, encryptAES, readAesResponsePayload, encryptAESforKYC, decrypttRSA}